// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 字体 */\n/* Colors\n-------------------------- */\n/* 尺寸\n-------------------------- */\n.svg-icon[data-v-abc9f7ae] {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  overflow: hidden;\n  outline: none;\n  fill: currentColor;\n}\n.svg-icon svg[data-v-abc9f7ae] {\n    fill: currentColor;\n}\n", ""]);
// Exports
module.exports = exports;
